import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface IDeleteIdentityProvider {
  deleteIdentityProvider: UserSuccessOutput;
}

export const DELETE_IDENTITY_PROVIDER = gql`
  mutation deleteIdentityProvider($provider_name: String) {
    deleteIdentityProvider(provider_name: $provider_name) {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useDeleteIdentityProvider = (
  options: MutationHookOptions<IDeleteIdentityProvider, OperationVariables>,
) =>
  useMutation<IDeleteIdentityProvider, OperationVariables>(
    DELETE_IDENTITY_PROVIDER,
    options,
  );
